import { ROUTES } from "@routing/routes";
import { Button, Title } from "@common/index";
import { ComponentColor } from "@common/types";

export const ApplySuccessPage = () => {
    return (
        <div className="max-w-2xl mx-auto px-4 py-10 text-primary">
            <Title>Application Received</Title>
            <p className="text-base mt-6">
                We&apos;ve received your application. We&apos;ll review and
                notify you within 3-5 business days. Watch your inbox for an
                email from us: a link to set up your password, or, if this
                email already has an account, a note on how to sign in.
                Ordering unlocks after we approve your application.
            </p>

            <h2 className="text-xl font-bold mt-10">Still have questions?</h2>
            <div className="mt-4">
                <Button
                    to={ROUTES.SUPPORT}
                    color={ComponentColor.Primary}
                    className="normal-case"
                >
                    Contact Support
                </Button>
            </div>
        </div>
    );
};
